// extracted by mini-css-extract-plugin
export default {"EmailListContainer":"KteQlGvmAKoey85d7KV3"};